import { prepareFoodPhoto, type FoodPhotoSource } from "./browser-photo";
import { FoodRecognitionClient, type RecognizeFoodOptions } from "./client";
import type { FoodRecognitionResult } from "./types";

/**
 * Browser boundary for photo recognition. The source image is resized and
 * re-encoded before it leaves the device; only the resulting JPEG is sent to
 * the same-origin recognition endpoint.
 */
export class BrowserFoodRecognizer {
  constructor(private readonly client = new FoodRecognitionClient()) {}

  async recognize(
    source: FoodPhotoSource,
    options: RecognizeFoodOptions = {},
  ): Promise<FoodRecognitionResult> {
    throwIfAborted(options.signal);
    const image = await prepareFoodPhoto(source);
    throwIfAborted(options.signal);
    return this.client.recognize(image, options);
  }
}

function throwIfAborted(signal: AbortSignal | undefined): void {
  if (signal?.aborted) throw signal.reason ?? new DOMException("Aborted", "AbortError");
}
